import React from 'react';
import { componentService } from 'js/services/component.service';

export const PromotionInfo = React.lazy(() => import(/* webpackChunkName: "promotion-info" */ './PromotionInfo'));

componentService.registerPageComponents({ 'promotion-info': PromotionInfo });
